<template>
  <div
    class="wrapper popup-wrapper"
    :class="{
      'wrapper--open': initialOpen || isPopupOpen,
      'enter-animation': enterAnimation
    }"
  >
    <header class="header">
      <LogoLink
        class="logo"
        @click.native="$store.commit('togglePopup', $store.state.activePopup)"
      />

      <ButtonClose
        color="white"
        @click.native="$store.commit('togglePopup', $store.state.activePopup)"
      />
    </header>

    <div class="content" :class="`content--${name}`">
      <slot name="title" />
      <div class="content__fraction fraction fraction--first">
        <slot name="first" />
      </div>

      <div class="content__fraction fraction fraction--second">
        <slot name="second" />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonClose from '@/components/common/ButtonClose'
import LogoLink from '@/components/common/LogoLink'

import gsap from 'gsap'

export default {
  components: {
    ButtonClose,
    LogoLink
  },
  props: {
    initialOpen: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    enterAnimation: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isPopupOpen() {
      return this.$store.state.activePopup === this.name
    }
  },
  watch: {
    isPopupOpen(value) {
      gsap.to('.section-wrapper--last', {
        y: value ? '-80px' : '0',
        duration: 0.8,
        ease: value ? 'power3.easeIn' : 'power1.easeInOut'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: $vh;

  z-index: z(popup);
  overflow-x: hidden;

  display: flex;
  flex-direction: column;
  justify-content: center;

  background: $background-color;

  padding: 220px 75px 45px;

  @include media-down(xl) {
    padding: 170px 75px 45px;
  }

  @include media-down(lg) {
    padding: 30px 100px 0 45px;
    justify-content: flex-start;
  }

  @include media-down(md) {
    padding: 16px 20px;
  }

  &.enter-animation {
    transform: translate3d(0, 100%, 0);
    opacity: 0;
    transition: transform 0.5s ease-in, opacity 1s 0.5s;
  }

  &--open {
    &.enter-animation {
      overflow-y: auto;
      opacity: 1;
      transform: translate3d(0, 0, 0);
      transition: transform 0.5s ease-in;
    }
  }
}

.logo {
  @include media-up(lg) {
    position: fixed;
    top: 50px;
    left: 5vw;
  }
}

.header {
  @include media-down(lg) {
    padding-bottom: 45px;
  }
}

.content {
  display: flex;

  padding: 0 9vw;

  @include media-down(xl) {
    padding: 0 6vw;
  }

  @include media-down(lg) {
    flex-direction: column;
    padding: 0;
  }

  &--contact {
    @include media-down(lg) {
      position: relative; // for agreement to scroll to on mobile
    }
  }
}

.fraction {
  flex-basis: 50%;

  &--first {
    margin-right: 6vw;

    @include media-down(lg) {
      margin-right: 0;
    }
  }

  &--second {
    @include media-down(lg) {
      margin-bottom: 30px;
    }
  }
}
</style>
